import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from './appsettings.service';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

    constructor(
        private authService: AdalService,
        private appSettingsService: AppSettingsService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (this.authService.userInfo.isAuthenticated) {
            return new Promise((res) => { res(); }).then(() => { return true; });
        }

        return this.appSettingsService.getAppSettings().then(() => { return true });
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/services/authguard.service.ts
 **/